module.exports = require("regenerator-runtime");



/*****************
 ** WEBPACK FOOTER
 ** ./~/react-scripts/~/babel-runtime/regenerator/index.js
 ** module id = 676
 ** module chunks = 0
 **/